import { render, staticRenderFns } from "./EventHandoutList.vue?vue&type=template&id=06407533&"
import script from "./EventHandoutList.vue?vue&type=script&lang=js&"
export * from "./EventHandoutList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports